import { render, staticRenderFns } from "./addGroupBuy.vue?vue&type=template&id=9e6663b0&scoped=true&"
import script from "./addGroupBuy.vue?vue&type=script&lang=js&"
export * from "./addGroupBuy.vue?vue&type=script&lang=js&"
import style0 from "./addGroupBuy.vue?vue&type=style&index=0&id=9e6663b0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e6663b0",
  null
  
)

export default component.exports